import { Avatar, Box, Typography } from '@mui/material'
import React from 'react'
import { stringAvatar } from 'utils/functions'

const InfoUserSSO = ({ username, SSOInfo }) => {
    const { avatar, email, name } = SSOInfo;

    const renderAvatar = () => {
        if(avatar) {
            return (
                <Avatar src={avatar} sx={{ width: '40px', height: '40px', borderRadius: '12px' }} variant="rounded" />
            )
        }
        return (
            <Avatar sx={{ width: '40px', height: '40px', borderRadius: '12px', m: 0 }} {...stringAvatar(username, SSOInfo, true)} />
        )
    }

    return (
        <Box component={'div'} id='info-user-sso' bgcolor={'#F7F7F7'} display={'flex'} alignItems={'center'} p={'10px 18px'} borderRadius={'12px'}>
            {renderAvatar()}
            <Box pl={1.25}>
                <Typography fontSize={18} fontWeight={700}>{name} zzzzzz</Typography>
                <Typography sx={{ wordBreak: 'break-all' }}>{email} zzzzzzzzz</Typography>
            </Box>
        </Box>
    )
}

export default InfoUserSSO